<div class="flex w-full justify-between items-start cursor-pointer p-10 hover:bg-blue-50 transition-colors duration-150" 
  (click)="openStartEAppModal()">
  <div class="flex flex-col gap-y-5 max-w-280">
    <span class="font-bold">Start E-Application Client Search</span>
    <span class="text-sm">Search your {{crmName ? crmName + ' ' : ''}}contacts while submitting E-applications, and client information for the selected contact will automatically pre-fill in Firelight or iGo.</span>
  </div>
  <span class="bg-green-200 rounded-full px-20 py-5">Connected</span>
</div>